// Every word the Accelerator's own pages say, in 1 place. The board's own words (Accelerator.dc.html)
// are copied exactly; the database's lines are docs/data-model.md 10.6.1's; every other line is
// marked "undrawn" and waits for Adam's batch. The Accelerator is a group, never a room, and nothing
// here pitches anything.
import { LIMITS, limitWords } from './limits.js'

export const SAVE_FAILED = "That didn't save. Check your connection and try again."

export const COPY = {
  // Your goal (the board)
  goal: 'Your goal',
  lockedOn: date => `Locked ${date}`,
  // the membership month, counted as the term counts it, apart from the month of actions on This month's actions (the
  // Accelerator critique's admin 2, on the member side: Adam's yes of 22 Oct)
  monthOf: (m, n) => `Membership month ${m} of ${n}`,
  setWithAdam: 'Set with Adam at your first session',
  // undrawn: past the 12-month term (access follows the subscription, so nothing ends on its own)
  pastTerm: (m, n) => `Membership month ${m}, past the ${n}-month term`,
  // undrawn: the goal before Adam locks it. The 2 lines are the board's checklist words; once the
  // member's group has held a session (or Adam has unlocked the goal since), "next" for "first"
  draft: 'Draft',
  noGoal: (n, later) => `Draft the goal you want to hit in ${n} months. You lock it in with Adam at your ${later ? 'next' : 'first'} session.`,
  draftLine: later => `You lock it in with Adam at your ${later ? 'next' : 'first'} session.`,
  goalField: 'Your goal',
  saveGoal: 'Save your goal',
  changeGoal: 'Change your goal',
  cancel: 'Cancel',
  // 10.6.1's lines for the database's refusals, with the limits widened for the Accelerator's move (11 Oct 2026)
  goalLocked: 'Your goal is locked. Ask Adam if it needs to change.',
  goalLength: `Write your goal in up to ${limitWords(LIMITS.goal)} characters.`,

  // Next session (the board)
  nextSession: 'Next session',
  onZoom: (time, group) => `${time} on Zoom, ${group}`,
  // undrawn (the critique's member 14, 20 Oct): the time from the session's start to its end, "5pm to 8:30pm"
  fromTo: (start, end) => `${start} to ${end}`,
  // undrawn (member 5): the Sessions page, from the next session's card
  allSessions: 'All sessions',
  // undrawn (member 9): their latest missed session, its recording still not watched
  missedSession: day => `You missed ${day}.`,
  watchRecording: 'Watch the recording',
  // undrawn: a session for every group
  everyGroup: 'every group',
  joinOpensAt: time => `Join opens at ${time}`,
  // the Library's and The Funding Engine's approved label
  join: 'Join on Zoom',
  addToCalendar: 'Add to calendar',
  added: 'Added to your calendar',
  attendance: (attended, total) => `Attendance: ${attended} of ${total} ${total === 1 ? 'session' : 'sessions'}`,
  // the board's attendance line in the log's own words, from the log's own count (member 1, 20 Oct)
  attendedLive: (live, total) => `${live} of ${total} ${total === 1 ? 'session' : 'sessions'} attended live`,
  // undrawn: before any register is taken for them, and the excused absences, which don't count
  noRegister: 'Attendance: no register taken yet',
  excused: n => `, ${n} excused`,
  // undrawn: every session so far excused, so nothing is counted yet (Adam's answer 11 of 7 Oct)
  allExcused: n => `Attendance: ${n} ${n === 1 ? 'session' : 'sessions'} excused`,
  // where they stand, from their accountability log (the plan's question 2 on its default: the log's state, never the
  // absences alone),
  // and the pill opens the log
  logState: { on_track: 'On track', a_little_behind: 'A little behind', behind: 'Behind', well_behind: 'Well behind', getting_started: 'Getting started' },
  viewLog: 'View accountability log',
  // the big button under the goal, the 1 way in from the home (Adam, 18 Oct, 16:12)
  viewYourLog: 'View your accountability log',
  // undrawn: no session set yet
  noNextSession: "Adam hasn't set the next session yet.",

  // This month's actions (the board)
  thisMonth: "This month's actions",
  // the month of actions, apart from the membership month on the goal (the critique's admin 2, on the member side)
  setAt: (month, date) => `Month ${month}'s actions, set at the session on ${date}`,
  monthOnly: month => `Month ${month}'s actions`,
  // "ticked", since a tick doesn't settle an action, Adam's review does (member 7, 20 Oct)
  done: (k, n) => `${k} of ${n} ticked`,
  carriedFrom: month => `Carried over from month ${month}`,
  // the same footer on the home and the Actions page, and none with no actions (member 7)
  actionsFoot: "Adam sets your actions with you at each session and carries over anything not done. Tick them off as you go, and add a note if something's in the way.",
  // undrawn (member 6): under the count, when this month's actions are due
  dueAt: day => `Due at your session on ${day}.`,
  // undrawn
  carried: 'Carried over',
  noActions: 'No actions for this month yet. Adam sets them with you at the session.',
  actionClosed: "This action's month has closed, so it can't be changed now.",

  // Your group (the board)
  yourGroup: 'Your group',
  groupLine: group => `Post in the ${group} WhatsApp between sessions. Adam answers there, so everybody learns from each other's questions.`,
  joinGroup: group => `Join the ${group} WhatsApp`,
  openedWhatsApp: 'Opened WhatsApp',
  // 10.6.1
  noWhatsApp: "Adam hasn't added the group's WhatsApp link yet.",
  // undrawn: a member Adam hasn't put in a group yet
  noGroup: 'Adam puts you in a group before your first session. Its WhatsApp link shows here then.',

  // Your wins (the board)
  wins: 'Your wins',
  addWin: 'Add a win',
  winField: 'What happened',
  winPlaceholder: 'What happened? e.g. Offer accepted on the 3-bed',
  categories: [['deal', 'Deal'], ['finance', 'Finance'], ['income', 'Income'], ['marketing', 'Marketing'], ['milestone', 'Milestone']],
  saveWin: 'Save the win',
  today: 'today',
  winMeta: (category, date) => `${category}, ${date}`,
  // design 4.5's share flag, in the live site's words; on a win staff logged it's the 1 thing the member
  // changes, in place (Adam, 7 Oct), with winSaved and SAVE_FAILED, so it needs no new words
  share: 'Happy for Adam to share this win?',
  // 10.6.1
  winTitle: `Give the win a title of up to ${limitWords(LIMITS.winTitle)} characters.`,
  // undrawn: a win's "More about it" (Adam's yes of 11 Oct, for the Accelerator's move): the staff panel's
  // name for it (src/admin/mastermind/words.js), shown under the win's kind and date and typed under its
  // words; the length line in the goal's pattern
  winDetail: 'More about it',
  winDetailPlaceholder: 'More about it, if you like: who was involved, what it means',
  winDetailLength: max => `Write more about it in up to ${max.toLocaleString('en-GB')} characters.`,
  // undrawn
  noWins: 'No wins yet. Add one when something goes your way.',
  // undrawn (member 5, 20 Oct): the home shows the latest 3, and this opens the rest in place
  seeAllWins: 'See all your wins',
  categoryLabel: 'What kind of win',
  // undrawn: Edit on a win the member logged (Adam's answer 6 of 7 Oct, and his follow-up: only on the
  // wins they logged), in the staff panel's words where they fit (src/admin/mastermind/words.js)
  edit: 'Edit',
  editLabel: title => `Edit: ${title}`,
  deleteWin: 'Delete',
  deleteConfirm: title => `Delete "${title}"? It can't be undone.`,
  deleteYes: 'Delete it',
  keep: 'Keep it',
  winSaved: 'Win saved.',
  winDeleted: 'Win deleted.',
  deleteFailed: "That didn't delete. Check your connection and try again.",

  // The Actions page (undrawn: no board draws it)
  actionsH1: 'Actions',
  addNote: 'Add a note for Adam',
  changeNote: 'Change your note',
  yourNote: 'Your note',
  noteField: 'Your note on this action',
  notePlaceholder: "How it's going, or what's in the way",
  saveNote: 'Save the note',
  noteLength: `A note can be up to ${limitWords(LIMITS.note)} characters.`,
  pastMonths: 'Past months',
  // the Actions page's past months, in 1 line pointing to the log (member 7, 20 Oct)
  pastInLog: 'How every past month went is in your',
  pastInLogLink: 'accountability log',
  carriedTo: month => `Carried over to month ${month}`,

  // The Group page (undrawn: no board draws it). The directory is the whole Accelerator's, every group
  // (Adam's answer 1 of 7 Oct), so its lines name the product, not the member's group
  groupH1: 'Group',
  directory: 'Member directory',
  directoryLine: product => `Members of ${product} who show themselves here, from their account. Nobody's email or phone number is shown.`,
  // 10.6.1
  directoryEmpty: product => `Nobody in ${product} is in the directory yet. Switch yourself on in Account, under About you.`,
  // undrawn
  notListed: "You're not in the directory, so other members can't see you here. Switch yourself on in Account, under About you.",
  openAccount: 'Open your account',
  you: 'You',
  directoryFailed: "The directory didn't load. Check your connection and try again.",
  tryAgain: 'Try again',

  // The home's shorter sections (the critique's member 5, 20 Oct; undrawn): the latest recording, with Watch and the
  // Recordings page; Resources as a shortcut to each tab, with its count
  latestRecording: 'Latest recording',
  allRecordings: 'All recordings',
  watch: 'Watch',
  resources: 'Resources',
  // what a tap on a resource does (member 15), after "New, added 23 Sep" where it's new
  tapLine: { download: 'Downloads', tool: 'Opens in a new tab', link: 'Opens in a new tab', here: 'Opens here', video: 'Plays here', copy: 'Copies the text' },

  // the page's own rows didn't load (the product pages' approved words)
  loadFailed: "That didn't load",
}

// "Marketing" for 'marketing'
export function categoryName(key) {
  return (COPY.categories.find(([k]) => k === key) || [key, key])[1]
}
